import React, { useState } from "react";
import { Form, Input, Button, Typography } from "antd";
import { ArrowLeftOutlined, CameraOutlined } from "@ant-design/icons";
import { saveCreditCard } from "../../../api/CreditCardApi";

const AddCreditCardForm = ({ onBack, onCardAdded }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [allFilled, setAllFilled] = useState(false);

  // Watch form fields to enable button
  const handleFieldsChange = (_, allFields) => {
    setAllFilled(
      allFields.every(
        (field) =>
          field.value && field.value !== ""
      ) 
    );
  };

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const payload = {
        cardNo: values.cardNo,
        name: values.name,
        expireDate: values.expireDate,
        cvv: Number(values.cvv),
      };
      await saveCreditCard(payload);
      if (onCardAdded) onCardAdded();
    } catch (err) {
      // handle error gracefully
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        width: "100%",
        maxWidth: 480,
        margin: "0 auto",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        background: "#F9FAFB",
      }}
    >
      {/* Top bar */}
      <div
        style={{
          height: 56,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 16px",
          borderBottom: "1px solid #eee",
          background: "#fff",
          position: "sticky",
          top: 0,
          zIndex: 10,
        }}
      >
        <ArrowLeftOutlined
          onClick={onBack}
          style={{ fontSize: 22, color: "#213C6F", cursor: "pointer" }}
        />
        <Typography.Text style={{ fontWeight: 600, fontSize: 16 }}>
          Add Credit Card
        </Typography.Text>
        <CameraOutlined
          style={{ fontSize: 22, color: "#213C6F", cursor: "pointer" }}
        />
      </div>

      {/* Form content */}
      <div style={{ flex: 1, padding: "24px 16px" }}>
        <Form
          layout="vertical"
          name="addCardForm" // 👈 give the form a name
          form={form}
          onFinish={onFinish}
          onFieldsChange={handleFieldsChange}
          style={{ maxWidth: "100%" }}
        >
          <Form.Item
            name="cardNo"
            rules={[
              { required: true, message: "Card number required" },
              { pattern: /^\d{12,19}$/, message: "Enter valid card number" },
            ]}
          >
            <Input
              type="number"
              placeholder="Card Number"
              style={{
                background: "#fff",
                borderRadius: 12,
                height: 50,
                fontSize: 16,
              }}
              maxLength={19}
            />
          </Form.Item>

          <Form.Item
            name="name"
            rules={[{ required: true, message: "Name required" }]}
          >
            <Input
              placeholder="Name on Card"
              style={{
                background: "#fff",
                borderRadius: 12,
                height: 50,
                fontSize: 16,
              }}
              maxLength={40}
            />
          </Form.Item>

          <div style={{ display: "flex", gap: "12px" }}>
            <Form.Item
              name="expireDate"
              rules={[
                { required: true, message: "Expiry required" },
                {
                  pattern: /^(0[1-9]|1[0-2])\/\d{2,4}$/,
                  message: "MM/yy or MM/yyyy",
                },
              ]}
              style={{ flex: 1, marginBottom: 0 }}
            >
              <Input
                placeholder="MM/YY"
                style={{
                  background: "#fff",
                  borderRadius: 12,
                  height: 50,
                  fontSize: 16,
                  textAlign: "center",
                }}
              />
            </Form.Item>

            <Form.Item
              name="cvv"
              rules={[
                { required: true, message: "CVV required" },
                { pattern: /^\d{3,4}$/, message: "CVV must be 3 or 4 digits" },
              ]}
              style={{ flex: 1, marginBottom: 0 }}
            >
              <Input
                type="number"
                placeholder="CVV"
                style={{
                  background: "#fff",
                  borderRadius: 12,
                  height: 50,
                  fontSize: 16,
                  textAlign: "center",
                }}
                maxLength={4}
              />
            </Form.Item>
          </div>
        </Form>
      </div>

      {/* Sticky Submit Button */}
      <div
        style={{
          padding: "12px 16px",
          borderTop: "1px solid #eee",
          background: "#fff",
          position: "sticky",
          bottom: 70, // 👈 pushes it up above your footer menu height
          zIndex: 20,
        }}
      >
        <Button
          type="primary"
          htmlType="submit"
          form="addCardForm"
          loading={loading}
          disabled={!allFilled}
          style={{
            background: allFilled
              ? "linear-gradient(90deg,#021b79,#0575E6)"
              : "#cbd5e1",
            color: "#fff",
            borderRadius: 12,
            width: "100%",
            height: 52,
            fontWeight: 600,
            fontSize: 17,
            border: "none",
            opacity: allFilled ? 1 : 0.7,
          }}
        >
          Add Credit Card
        </Button>
      </div>
    </div>
  );
};

export default AddCreditCardForm;
